/*
 * Copyright (c) 2025-2026 Aegis AO Soft LLC and Alexander Orlov.
 * Confidential and proprietary. Author: Alexander Orlov.
 *
 * Tenant "About" page: hero + the owner's Sections (Design editor → Sections tab), rendered page-wide
 * like aegis-ao-rental_web. Falls back to a sensible default when the owner has authored no sections.
 */

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTenant } from '../contexts/TenantContext';
import PageHero from '../components/PageHero';
import { pickLocalized } from '../utils/localized';
import SectionsRenderer, { parseSections } from '../components/SectionsRenderer';

export default function AboutPage() {
  const { t, i18n } = useTranslation();
  const { tenant } = useTenant();
  const name = tenant?.displayName || t('about.us', 'us');
  const tagLine = pickLocalized(tenant?.tagLineJson, tenant?.tagLine, i18n.language);
  const hasSections = parseSections(tenant?.sectionsJson).length > 0;

  return (
    <>
      <PageHero title={t('about.title', 'About {{name}}', { name })} subtitle={tagLine || undefined} />
      {hasSections ? (
        <SectionsRenderer json={tenant?.sectionsJson} />
      ) : (
        <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="bg-white rounded-lg shadow-lg p-8 md:p-12 text-gray-700">
            <div className="space-y-4 text-lg leading-relaxed">
              <p>{t('about.default1', '{{name}} makes renting a car simple, fast and transparent. Pick your dates, choose a vehicle that fits your trip, and book online in minutes.', { name })}</p>
              <p>{t('about.default2', 'We keep our fleet well-maintained and our pricing clear, so you can drive away with confidence.', { name })}</p>
            </div>
            <div className="mt-8">
              <Link to="/" className="btn-primary inline-flex items-center py-3 px-6">
                {t('about.browse', 'Browse our cars')}
              </Link>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
